import { ExternalLinks } from '@/@core/services/api'
import {
  Box,
  Button,
  IconButton,
  InputBase,
  Link,
  Paper,
  Stack,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Tabs,
  Tooltip,
  Typography
} from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'
import { OpenInNew } from 'mdi-material-ui'
import * as React from 'react'
import { styled } from '@mui/material/styles'
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp'
import MuiAccordion, { AccordionProps } from '@mui/material/Accordion'
import MuiAccordionSummary, {
  AccordionSummaryProps
} from '@mui/material/AccordionSummary'
import MuiAccordionDetails from '@mui/material/AccordionDetails'
import { useTranslation } from 'react-i18next'

import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import CardMedia from '@mui/material/CardMedia'
import { CardActionArea } from '@mui/material'
import {
  analyzeArticle,
  AnalyzeArticleDto,
  ChatClaudeDto,
  getChatgpt_Multurn_qa,
  getVarDetail,
  GetVariantLiteratureDto,
  translate as translateByQwen,
  TranslateBulkDto,
  TranslateDto,
  translates,
  VariantDetailHGMDInfo
} from '@/@core/services/app.service'
import { useMutation } from 'react-query'
import AnalyzeVariants from './AnalyzeVariant'
import LoadingButton from '@mui/lab/LoadingButton'
import { PsychologyAlt, PsychologyAltOutlined } from '@mui/icons-material'
import { formatDate, isWindow } from '@/@core/utils/utils'
import Pagination from '@mui/material/Pagination'
import PaginationItem from '@mui/material/PaginationItem'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'

import * as pdfjsLib from 'pdfjs-dist/legacy/build/pdf'
import _ from 'lodash'
import { NObject } from '@/@core/components/filter-variants'

pdfjsLib.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js`

interface TabPanelProps {
  children?: React.ReactNode
  index: number
  value: number
}
interface Msg {
  message: string
  sentTime: string
  sender: string
  direction: MessageDirection
  position: string
}
enum MessageDirection {
  IN = 'incoming',
  OUT = 'outgoing'
}

const ACMGClassification = [
  {
    key: 'Pathogenic',
    title: 'Pathogenic',
    color: 'rgba(229,38,35,0.8)',
    hoverColor: 'rgb(229,38,35,0.6)'
  },
  {
    key: 'Likely pathogenic',
    title: 'Likely Pathogenic',
    color: 'rgb(221,109,32)',
    hoverColor: 'rgb(221,109,32,0.6)'
  },
  {
    key: 'Uncertain significance',
    title: 'Uncertain Significance',
    color: 'rgb(255,180,0)',
    hoverColor: 'rgb(255,180,0,0.6)'
  },
  {
    key: 'Likely benign',
    title: 'Likely Benign',
    color: 'rgb(107,148,200)',
    hoverColor: 'rgb(107,148,200,0.6)'
  },
  {
    key: 'Benign',
    title: 'Benign',
    color: 'rgb(103,142,197)',
    hoverColor: 'rgb(103,142,197,0.6)'
  },
  {
    key: '.',
    title: 'None',
    color: 'rgb(46, 125, 50,.6)',
    hoverColor: 'rgb(46, 125, 50,0.4)'
  }
]

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  )
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`
  }
}

const Accordion = styled((props: AccordionProps) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  '&:not(:last-child)': {
    borderBottom: 0
  },
  '&:before': {
    display: 'none'
  },
  '& .MuiAccordionSummary-root': {
    minHeight: '36px !important'
  }
}))

const AccordionSummary = styled((props: AccordionSummaryProps) => (
  <MuiAccordionSummary expandIcon={null} {...props} />
))(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === 'dark'
      ? 'rgba(255, 255, 255, .05)'
      : 'rgba(0, 0, 0, .03)',
  flexDirection: 'row-reverse',
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(90deg)'
  },
  '& .MuiAccordionSummary-root': {
    minHeight: '36px !important'
  },
  '& .MuiAccordionSummary-content': {
    margin: '0 !important',
    marginLeft: theme.spacing(1)
  }
}))

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: '1px solid rgba(0, 0, 0, .125)'
}))

export const Article = (props: {
  value: any
  type: string
  row: any
  handleOpen: any
  summarization?: string
  acmg?: any[]
  acmg_classification?: string
  acmg_summary?: string
}) => {
  const { t } = useTranslation()
  const [expand, setExpand] = React.useState(false)
  const [analyzeArticles, setAnalyzeArticles] = React.useState<any>()
  const [isFinish, setIsFinish] = React.useState<boolean>(false)
  const [isTranslateFinish, setIsTranslateFinish] =
    React.useState<boolean>(false)
  const [translate, setTranslate] = React.useState<NObject>({})

  const AnalyzeArticle = useMutation({
    mutationFn: async (data: AnalyzeArticleDto) => await analyzeArticle(data),
    onSuccess: (datas: any) => {
      //post返回的结果

      setAnalyzeArticles(datas)
    },
    onError: (err) => {
      //

      setIsFinish(false)
    }
  })

  const Translates = useMutation({
    mutationFn: async (data: { params: TranslateBulkDto; key: string[] }) =>
      await translates(data.params),
    onSuccess: (
      data: { translated: string; wordCount: string; index: string }[],
      params
    ) => {
      //post返回的结果

      if (params.params.sourceLanguage === 'en') {
        const obj: NObject = {}
        const terms = data.map((items) => {
          const key = params.key[Number(items.index)]
          if (key === 'evidences') {
            obj[key] = items.translated.split('///')
          } else obj[key] = items.translated

          return {
            valueCN: items.translated,
            key
          }
        })

        //

        setTranslate(obj)
      }
    }
  })

  const Translate = useMutation({
    mutationFn: async (data: TranslateDto) => await translateByQwen(data),
    onSuccess: (data, params, context) => {
      //post返回的结果
    }
  })

  const HighlightText = ({ text, highlightPatternString }: any) => {
    // 将字符串转换为正则表达式

    const highlightPattern = new RegExp(highlightPatternString, 'gi')

    // 使用replace方法和高亮函数来替换匹配的文本

    const highlightedText =
      highlightPatternString && highlightPatternString.includes('|') && text
        ? text.replace(
            highlightPattern,

            (match: any) => `<mark>${match}</mark>`
          )
        : text

    // 注意：使用dangerouslySetInnerHTML需要谨慎

    return <div dangerouslySetInnerHTML={{ __html: highlightedText }} />
  }

  const higlitghtStr = [props.row.gene, props.row.p_nomen, props.row.c_nomen]
    .filter((item) => item && item !== '.')
    .join('|')
  const highlightPatternString = `\\b(${higlitghtStr})\\b` // 使用双反斜杠来转义反斜杠

  //

  if (props.type === 'LitVar') {
    return (
      <React.Fragment>
        {props.value ? (
          <Card
            key={`${props.value.url}`}
            sx={{
              mb: 2
            }}
          >
            <CardContent>
              <Box key={`${props.value.url}`}>
                <Stack
                  direction={'row'}
                  alignItems="center"
                  justifyContent={'space-between'}
                >
                  <Typography fontSize={12} color="primary.main">
                    <Typography
                      component={'span'}
                      fontSize={12}
                      sx={{
                        ':after': {
                          content: '""',
                          bgcolor: '#039be5',
                          width: '5px',
                          height: '5px',
                          display: 'inline-block',
                          borderRadius: '50%',
                          mx: 1
                        },
                        cursor: 'pointer',
                        ':hover': {
                          textDecoration: 'underline'
                        },
                        color: '#039be5'
                      }}
                      onClick={(e) => {
                        e.stopPropagation()

                        window.open(
                          `${ExternalLinks.ncbi.pubmed}/${props.value.pmid}`
                        )
                      }}
                    >
                      {`PMID${props.value.pmid}`}
                    </Typography>

                    {props.value.pmcid ? (
                      <Typography
                        component={'span'}
                        fontSize={12}
                        sx={{
                          cursor: 'pointer',
                          ':hover': {
                            textDecoration: 'underline'
                          },
                          color: '#039be5'
                        }}
                        onClick={(e) => {
                          e.stopPropagation()

                          window.open(
                            `${ExternalLinks.ncbi.articles}/${props.value.pmcid}`
                          )
                        }}
                      >
                        {`${props.value.pmcid}`}
                      </Typography>
                    ) : (
                      ''
                    )}
                  </Typography>

                  <Typography
                    component={'span'}
                    fontSize={12}
                    sx={{
                      cursor: 'pointer',
                      ':hover': {
                        textDecoration: 'underline'
                      },
                      color: '#039be5'
                    }}
                  >
                    {formatDate(props.value.date, 'YYYY-MM-DD')}
                  </Typography>
                </Stack>

                <Typography fontSize={18} color="#237aaa" py={1}>
                  <HighlightText
                    text={props.value.title}
                    highlightPatternString={highlightPatternString}
                  />
                </Typography>

                <Typography
                  fontSize={14}
                  fontWeight={200}
                  component={'p'}
                  color="primary.main"
                >
                  <Typography
                    component={'span'}
                    sx={{
                      display: 'inline-block',
                      maxWidth: 150,
                      overflow: 'hidden',
                      whiteSpace: 'nowrap',
                      textOverflow: 'ellipsis'
                    }}
                    fontSize={14}
                    fontWeight={200}
                    color={'#8c9296'}
                  >
                    {props.value.authors.join(',')}
                  </Typography>

                  <Typography
                    component={'span'}
                    sx={{
                      display: 'inline-block',
                      maxWidth: 250,
                      overflow: 'hidden',
                      whiteSpace: 'nowrap',
                      textOverflow: 'ellipsis',
                      ':before': {
                        content: '""',
                        bgcolor: '#039be5',
                        width: '8px',
                        height: '8px',
                        display: 'inline-block',
                        borderRadius: '50%',
                        mx: 1
                      }
                    }}
                    fontSize={14}
                    fontWeight={200}
                    color={'#8c9296'}
                  >
                    {props.value.journal}
                  </Typography>

                  <Box
                    textAlign={'end'}
                    display="inline-block"
                    sx={{
                      float: 'right'
                    }}
                  >
                    {props.value.pmcid ? (
                      <LoadingButton
                        disabled={!props.value.pmcid}
                        onClick={async (e) => {
                          e.stopPropagation()

                          const analyzeArticleParams = {
                            title: props.value.title,
                            abstract: '',
                            url: `${ExternalLinks.ncbi.articles}/${props.value.pmcid}`
                          }

                          if (!analyzeArticles) {
                            // props.handleOpen && props.handleOpen(true)
                            setIsFinish(true)

                            await AnalyzeArticle.mutateAsync(
                              analyzeArticleParams
                            )

                            // props.handleOpen && props.handleOpen(false)
                            setIsFinish(false)
                          } else {
                            setAnalyzeArticles('')
                          }
                        }}
                        variant="contained"
                        sx={{
                          textTransform: 'capitalize'
                        }}
                        loading={isFinish}
                        endIcon={<PsychologyAltOutlined />}
                      >
                        {t('AI interpretation')}
                      </LoadingButton>
                    ) : (
                      ''
                    )}
                  </Box>
                </Typography>

                {props.value.snippets && props.value.snippets.length ? (
                  <Typography
                    fontSize={16}
                    sx={{
                      cursor: 'pointer'
                    }}
                    pt={2}
                  >
                    <HighlightText
                      text={props.value.snippets[0].snip_text}
                      highlightPatternString={highlightPatternString}
                    />
                  </Typography>
                ) : (
                  ''
                )}

                <Box>
                  {analyzeArticles ? (
                    <AnalyzeVariants value={analyzeArticles} />
                  ) : (
                    ''
                  )}
                </Box>
              </Box>
            </CardContent>
          </Card>
        ) : (
          <Typography textAlign={'center'}>{t('No Results')}</Typography>
        )}
      </React.Fragment>
    )
  } else if (props.type === 'variants') {
    return (
      <React.Fragment>
        {props.value ? (
          <Card
            key={`${props.value.pmid}`}
            sx={{
              mb: 2
            }}
          >
            <CardContent>
              <Box key={`${props.value.pmid}`}>
                <Stack
                  direction={'row'}
                  alignItems="center"
                  justifyContent={'space-between'}
                >
                  <Typography
                    fontSize={12}
                    color="primary.main"
                    onClick={(e) => {
                      e.stopPropagation()

                      window.open(
                        `${ExternalLinks.ncbi.articles}/${props.value.pmc}`
                      )
                    }}
                  >
                    <Typography
                      component={'span'}
                      fontSize={12}
                      sx={{
                        ':after': {
                          content: '""',
                          bgcolor: '#039be5',
                          width: '5px',
                          height: '5px',
                          display: 'inline-block',
                          borderRadius: '50%',
                          mx: 1
                        },
                        cursor: 'pointer',
                        ':hover': {
                          textDecoration: 'underline'
                        },
                        color: '#039be5'
                      }}
                    >
                      {`PMID${props.value.pmid}`}
                    </Typography>

                    {props.value.pmc ? (
                      <Typography
                        component={'span'}
                        fontSize={12}
                        sx={{
                          cursor: 'pointer',
                          ':hover': {
                            textDecoration: 'underline'
                          },
                          color: '#039be5'
                        }}
                      >
                        {`PMC${props.value.pmc}`}
                      </Typography>
                    ) : (
                      ''
                    )}
                  </Typography>

                  <Typography
                    component={'span'}
                    fontSize={12}
                    sx={{
                      cursor: 'pointer',
                      ':hover': {
                        textDecoration: 'underline'
                      },
                      color: '#039be5'
                    }}
                  >
                    {formatDate(props.value.date, 'YYYY-MM-DD')}
                  </Typography>
                </Stack>

                {props.summarization ? (
                  <Typography fontSize={'1rem'} color="#237aaa" py={1}>
                    <HighlightText
                      text={props.summarization}
                      highlightPatternString={highlightPatternString}
                    />
                  </Typography>
                ) : (
                  ''
                )}

                <Typography fontSize={'1rem'} color="#237aaa" py={1}>
                  <HighlightText
                    text={translate.title ? translate.title : props.value.title}
                    highlightPatternString={highlightPatternString}
                  />
                </Typography>

                <Typography fontSize={16} py={1}>
                  <HighlightText
                    text={
                      translate.snippet
                        ? translate.snippet
                        : props.value.snippet
                    }
                    highlightPatternString={highlightPatternString}
                  />
                </Typography>

                <Typography fontSize={18} color="#237aaa" py={1}>
                  {'Inference:'}
                </Typography>

                {translate.evidences && translate.evidences.length
                  ? translate.evidences.map((item: string) => {
                      return (
                        <Typography
                          fontSize={16}
                          sx={{
                            cursor: 'pointer'
                          }}
                          pt={2}
                        >
                          <HighlightText
                            text={item}
                            highlightPatternString={highlightPatternString}
                          />
                        </Typography>
                      )
                    })
                  : props.value.evidences && props.value.evidences.length
                  ? props.value.evidences.map((item: string) => {
                      return (
                        <Typography
                          fontSize={16}
                          sx={{
                            cursor: 'pointer'
                          }}
                          pt={2}
                        >
                          <HighlightText
                            text={item}
                            highlightPatternString={highlightPatternString}
                          />
                        </Typography>
                      )
                    })
                  : ''}

                <Typography fontSize={18} color="#237aaa" py={1}>
                  {'Conclusion:'}
                </Typography>

                {props.value.conclusion ? (
                  <Typography fontSize={'1rem'} color="#237aaa" py={1}>
                    <HighlightText
                      text={
                        translate.conclusion
                          ? translate.conclusion
                          : props.value.conclusion
                      }
                      highlightPatternString={highlightPatternString}
                    />
                  </Typography>
                ) : (
                  ''
                )}

                <Typography
                  fontSize={14}
                  fontWeight={200}
                  component={'p'}
                  color="primary.main"
                >
                  {props.value.gene_mentions ? (
                    <Tooltip
                      title={props.value.gene_mentions.join(',')}
                      placement="top-start"
                    >
                      <Typography
                        component={'span'}
                        sx={{
                          display: 'inline-block',
                          maxWidth: 350,
                          overflow: 'hidden',
                          whiteSpace: 'nowrap',
                          textOverflow: 'ellipsis'
                        }}
                        fontSize={14}
                        fontWeight={200}
                        color={'#8c9296'}
                      >
                        {props.value.gene_mentions.join(',')}
                      </Typography>
                    </Tooltip>
                  ) : (
                    <Tooltip
                      title={props.value?.variant_mentions?.join(',')}
                      placement="top-start"
                    >
                      <Typography
                        component={'span'}
                        sx={{
                          display: 'inline-block',
                          maxWidth: 350,
                          overflow: 'hidden',
                          whiteSpace: 'nowrap',
                          textOverflow: 'ellipsis'
                        }}
                        fontSize={14}
                        fontWeight={200}
                        color={'#8c9296'}
                      >
                        {props.value?.variant_mentions?.join(',')}
                      </Typography>
                    </Tooltip>
                  )}

                  <Typography
                    component={'span'}
                    sx={{
                      display: 'inline-block',
                      maxWidth: 250,
                      overflow: 'hidden',
                      whiteSpace: 'nowrap',
                      textOverflow: 'ellipsis',
                      ':before': {
                        content: '""',
                        bgcolor: '#039be5',
                        width: '8px',
                        height: '8px',
                        display: 'inline-block',
                        borderRadius: '50%',
                        mx: 1
                      }
                    }}
                    fontSize={14}
                    fontWeight={200}
                    color={
                      props.value.label === 'pathogenic'
                        ? 'red'
                        : 'rgb(254,130,138)'
                    }
                  >
                    {props.value.label}
                  </Typography>

                  <Button
                    sx={{
                      float: 'right'
                    }}
                    variant="contained"
                    size="small"
                    onClick={async () => {
                      if (Object.keys(translate).length) {
                        setTranslate({})

                        return
                      }

                      const sourceLanguage = 'en',
                        targetLanguage = 'zh'
                      const obj = {} as any
                      const key = [
                        'title',
                        'evidences',
                        'snippet',
                        'conclusion',
                        'acmg'
                      ]

                      key.map((item, index) => {
                        const value = {
                          ...props.value,
                          acmg: props.acmg,
                          acmg_classification: props.acmg_classification,
                          acmg_summary: props.acmg_summary
                        }
                        if (Array.isArray(value[item])) {
                          obj[index] = value[item].join('///')
                        } else obj[index] = value[item]
                      })

                      const params: TranslateBulkDto = {
                        sourceText: obj,
                        sourceLanguage,
                        targetLanguage
                      }

                      await Translates.mutateAsync({
                        params,
                        key
                      })
                    }}
                  >
                    {t('translate')}
                  </Button>

                  <Box
                    textAlign={'end'}
                    display="inline-block"
                    sx={{
                      float: 'right'
                    }}
                  >
                    {props.value.pmcid ? (
                      <LoadingButton
                        disabled={!props.value.pmcid}
                        onClick={async (e) => {
                          e.stopPropagation()

                          const analyzeArticleParams = {
                            title: props.value.title,
                            abstract: '',
                            url: `${ExternalLinks.ncbi.articles}/${props.value.pmcid}`
                          }

                          if (!analyzeArticles) {
                            // props.handleOpen && props.handleOpen(true)
                            setIsFinish(true)

                            await AnalyzeArticle.mutateAsync(
                              analyzeArticleParams
                            )

                            // props.handleOpen && props.handleOpen(false)
                            setIsFinish(false)
                          } else {
                            setAnalyzeArticles('')
                          }
                        }}
                        variant="contained"
                        sx={{
                          textTransform: 'capitalize'
                        }}
                        loading={isFinish}
                        endIcon={<PsychologyAltOutlined />}
                      >
                        {t('AI interpretation')}
                      </LoadingButton>
                    ) : (
                      ''
                    )}
                  </Box>
                </Typography>

                <Box>
                  {analyzeArticles ? (
                    <AnalyzeVariants value={analyzeArticles} />
                  ) : (
                    ''
                  )}
                </Box>
              </Box>
            </CardContent>
          </Card>
        ) : (
          <Typography textAlign={'center'}>{t('No Results')}</Typography>
        )}
      </React.Fragment>
    )
  } else if (props.type === 'clinvar') {
    return (
      <React.Fragment>
        {props.value ? (
          <Card
            key={`${props.value.pmid}`}
            sx={{
              mb: 2
            }}
          >
            <CardContent>
              <Box key={`${props.value.pmid}`}>
                <Stack
                  direction={'row'}
                  alignItems="center"
                  justifyContent={'space-between'}
                >
                  <Typography
                    fontSize={12}
                    color="primary.main"
                    onClick={(e) => {
                      e.stopPropagation()

                      window.open(
                        `${ExternalLinks.ncbi.articles}/${props.value.pmcid}`
                      )
                    }}
                  >
                    <Typography
                      component={'span'}
                      fontSize={12}
                      sx={{
                        ':after': {
                          content: '""',
                          bgcolor: '#039be5',
                          width: '5px',
                          height: '5px',
                          display: 'inline-block',
                          borderRadius: '50%',
                          mx: 1
                        },
                        cursor: 'pointer',
                        ':hover': {
                          textDecoration: 'underline'
                        },
                        color: '#039be5'
                      }}
                    >
                      {`PMID${props.value.pmid}`}
                    </Typography>

                    {props.value.pmcid ? (
                      <Typography
                        component={'span'}
                        fontSize={12}
                        sx={{
                          cursor: 'pointer',
                          ':hover': {
                            textDecoration: 'underline'
                          },
                          color: '#039be5'
                        }}
                      >
                        {`${props.value.pmcid}`}
                      </Typography>
                    ) : (
                      ''
                    )}
                  </Typography>

                  <Typography
                    component={'span'}
                    fontSize={12}
                    sx={{
                      cursor: 'pointer',
                      ':hover': {
                        textDecoration: 'underline'
                      },
                      color: '#039be5'
                    }}
                  >
                    {formatDate(props.value.pub_date, 'YYYY-MM-DD')}
                  </Typography>
                </Stack>

                <Typography fontSize={'1rem'} color="#237aaa" py={1}>
                  <HighlightText
                    text={translate.title ? translate.title : props.value.title}
                    highlightPatternString={highlightPatternString}
                  />
                </Typography>

                {props.value.abstract ? (
                  <Typography fontSize={'1rem'} color="#237aaa" py={1}>
                    <HighlightText
                      text={
                        translate.abstract
                          ? translate.abstract
                          : props.value.abstract
                      }
                      highlightPatternString={highlightPatternString}
                    />
                  </Typography>
                ) : (
                  ''
                )}

                <Typography
                  fontSize={14}
                  fontWeight={200}
                  component={'p'}
                  color="primary.main"
                >
                  <LoadingButton
                    sx={{
                      float: 'right',
                      ml: 2,
                      mr: 2
                    }}
                    variant="contained"
                    size="small"
                    loading={isTranslateFinish}
                    onClick={async (e) => {
                      e.stopPropagation()
                      if (Object.keys(translate).length) {
                        setTranslate({})

                        return
                      }
                      setIsTranslateFinish(true)

                      const sourceLanguage = 'en',
                        targetLanguage = 'zh'
                      const obj = {} as any
                      const key = ['title', 'abstract']

                      await Promise.all(
                        key.map(async (item) => {
                          const params: TranslateDto = {
                            sourceText: props.value[item],
                            sourceLanguage,
                            targetLanguage
                          }

                          if (!props.value[item]) {
                            obj[item] = ''
                            return
                          }

                          const data = await Translate.mutateAsync(params)

                          if (data) {
                            obj[item] = data
                          } else {
                            obj[item] = props.value[item]
                          }
                        })
                      )

                      setTranslate(obj)
                      setIsTranslateFinish(false)

                      // key.map((item, index) => {
                      //   const value = {
                      //     ...props.value,
                      //     acmg: props.acmg,
                      //     acmg_classification: props.acmg_classification,
                      //     acmg_summary: props.acmg_summary
                      //   }
                      //   if (Array.isArray(value[item])) {
                      //     obj[index] = value[item].join('///')
                      //   } else obj[index] = value[item]
                      // })

                      // const params: TranslateBulkDto = {
                      //   sourceText: obj,
                      //   sourceLanguage,
                      //   targetLanguage
                      // }

                      // await Translates.mutateAsync({
                      //   params,
                      //   key
                      // })
                    }}
                  >
                    {t('translate')}
                  </LoadingButton>

                  <Box
                    textAlign={'end'}
                    display="inline-block"
                    sx={{
                      float: 'right'
                    }}
                  >
                    {props.value.pmcid ? (
                      <LoadingButton
                        disabled={!props.value.pmcid}
                        onClick={async (e) => {
                          e.stopPropagation()

                          const analyzeArticleParams = {
                            title: props.value.title,
                            abstract: '',
                            url: `${ExternalLinks.ncbi.articles}/${props.value.pmcid}`
                          }

                          if (!analyzeArticles) {
                            // props.handleOpen && props.handleOpen(true)
                            setIsFinish(true)

                            await AnalyzeArticle.mutateAsync(
                              analyzeArticleParams
                            )

                            // props.handleOpen && props.handleOpen(false)
                            setIsFinish(false)
                          } else {
                            setAnalyzeArticles('')
                          }
                        }}
                        variant="contained"
                        sx={{
                          textTransform: 'capitalize'
                        }}
                        size="small"
                        loading={isFinish}
                        endIcon={<PsychologyAltOutlined />}
                      >
                        {t('AI interpretation')}
                      </LoadingButton>
                    ) : (
                      ''
                    )}
                  </Box>
                </Typography>

                <Box>
                  {analyzeArticles ? (
                    <AnalyzeVariants value={analyzeArticles} />
                  ) : (
                    ''
                  )}
                </Box>
              </Box>
            </CardContent>
          </Card>
        ) : (
          <Typography textAlign={'center'}>{t('No Results')}</Typography>
        )}
      </React.Fragment>
    )
  } else
    return (
      <React.Fragment>
        {/* {props.type === 'scholar' ? (
          <Typography>Real-time search:</Typography>
        ) : (
          ''
        )} */}

        {props.value ? (
          <Card
            key={`${props.value.id}`}
            sx={{
              mb: 2
            }}
            onClick={() => {
              if (props.type !== 'scholar') setExpand(!expand)
            }}
          >
            <CardActionArea>
              <CardContent>
                <Box key={`${props.value.id}`}>
                  <Typography
                    onClick={() => {
                      window.open(props.value.url)
                    }}
                    fontSize={16}
                    color="primary.main"
                    sx={{
                      cursor: 'pointer'
                    }}
                  >
                    {`${props.value.title}`}
                  </Typography>

                  {props.value.excerpt && !expand ? (
                    <Typography fontSize={14} fontWeight={400}>
                      <HighlightText
                        text={props.value.excerpt}
                        highlightPatternString={highlightPatternString}
                      />
                    </Typography>
                  ) : (
                    ''
                  )}

                  {props.value.abstract && expand ? (
                    <Typography fontSize={14} fontWeight={400}>
                      <HighlightText
                        text={props.value.abstract}
                        highlightPatternString={highlightPatternString}
                      />
                    </Typography>
                  ) : (
                    ''
                  )}

                  <Typography
                    fontSize={14}
                    fontWeight={400}
                    component={'small'}
                    fontStyle={'italic'}
                    color="primary.main"
                  >
                    {`Year: ${props.value.year}${
                      props.value.source && props.value.source !== '.'
                        ? `-${props.value.source}`
                        : ''
                    };${
                      props.type === 'scholar'
                        ? `Cited by ${props.value.num_citations}; All ${props.value.num_versions} versions`
                        : ''
                    } `}
                  </Typography>

                  <Box textAlign={'end'}>
                    {props.value.abstract ? (
                      <LoadingButton
                        disabled={!props.value.abstract}
                        onClick={async (e) => {
                          e.stopPropagation()

                          const analyzeArticleParams = {
                            title: props.value.title,
                            abstract: props.value.abstract,
                            url: ''
                          }

                          if (!analyzeArticles) {
                            // props.handleOpen && props.handleOpen(true)
                            setIsFinish(true)

                            await AnalyzeArticle.mutateAsync(
                              analyzeArticleParams
                            )

                            // props.handleOpen && props.handleOpen(false)
                            setIsFinish(false)
                          } else {
                            setAnalyzeArticles('')
                          }
                        }}
                        variant="contained"
                        sx={{
                          textTransform: 'capitalize'
                        }}
                        loading={isFinish}
                        endIcon={<PsychologyAltOutlined />}
                      >
                        {t('AI interpretation')}
                      </LoadingButton>
                    ) : (
                      ''
                    )}
                  </Box>
                </Box>

                <Box>
                  {analyzeArticles ? (
                    <AnalyzeVariants value={analyzeArticles} />
                  ) : (
                    ''
                  )}
                </Box>
              </CardContent>
            </CardActionArea>
          </Card>
        ) : (
          <Typography textAlign={'center'}>{t('No Results')}</Typography>
        )}
      </React.Fragment>
    )
}

const RelatedLiterature = React.forwardRef(
  (
    props: {
      value: {
        variantPubmedArticles: any[]
        genePubmedArticles: any[]
        scholarArticles: any[]
        realtimeStatus: string
        details: any[]
      }
      row: any
      analysisInfo: any
      handleOpen: any
      litVarArticles: any
      setLitPage: any
      page: any
      getLitVarArticle: any
      hgmdValue: VariantDetailHGMDInfo[]
    },
    ref
  ) => {
    const { t } = useTranslation()
    const inputRef = React.useRef<HTMLInputElement | null>(null)
    const [file, setFile] = React.useState<File | null>()
    const [PdfArticle, setPdfArticle] = React.useState('')
    const [loading, setLoading] = React.useState(false)
    const [historyMsg, setHistoryMsg] = React.useState<Msg[]>([])
    const [acmg, setAcmg] = React.useState<string[]>([])
    const [variantsArticles, setVariantsArticles] = React.useState<any>({})

    const [value, setValue] = React.useState(0)
    const [value2, setValue2] = React.useState(0)
    const [translates, setTranslates] = React.useState('')
    const [search, setSearch] = React.useState<string>('')
    const [searchValue, setSearchValue] = React.useState<string>('')

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
      setValue(newValue)

      //

      if (newValue === 2) {
        const variantsParams = {
          assembly: props.analysisInfo.genomeBuild,
          variant: `${props.row.chrom}-${props.row.pos}-${props.row.REF}-${props.row.ALT}`,
          gene_name: props.row.gene
        }

        // if (variantsParams.assembly) getVarArticle.mutateAsync(variantsParams)
      }
    }
    const data = [
      {
        title: t('Publication')
      }
    ]

    const getChatClaudes = async (data: {
      messages: ChatClaudeDto
      his: Msg[]
    }) => {
      const list = []
      const flag = true

      for await (const result of getChatgpt_Multurn_qa(data.messages)) {
        // //

        list.push(result.content)

        //

        const dataStr = list
          .map((item) => {
            if (item && item !== '') return item
            else return '\n'
          })
          .join('')

        if (flag) {
          const newChat = [
            ...data.his,
            {
              message: dataStr,
              sentTime: formatDate(new Date()) ?? '',
              sender: 'assistant',
              direction: MessageDirection.IN,
              position: 'last'
            }
          ]

          setHistoryMsg(newChat)
        } else if (historyMsg.length) {
          const temp = _.cloneDeep(historyMsg)
          const lastMsg = temp[temp.length - 1]

          lastMsg.message = dataStr

          setHistoryMsg(temp)
        }
      }
    }

    const getVarArticle = useMutation({
      mutationFn: async (params: GetVariantLiteratureDto) =>
        await getVarDetail(params),
      onSuccess: (datas: any) => {
        //post返回的结果

        setVariantsArticles(datas)

        setAcmg(
          datas.details[0]?.acmg
            ?.filter((item: any) => item.code_status)
            .map((item: any) => `${item.code_name}:${item.evidence}`)
        )
      }
    })

    const Translate = useMutation({
      mutationFn: async (data: TranslateDto) => await translateByQwen(data),
      onSuccess: (data, params, context) => {
        //post返回的结果
      }
    })

    return (
      <Box>
        {historyMsg
          .filter((item) => item.direction === MessageDirection.IN)
          .map((item) => {
            return <Typography>{item.message}</Typography>
          })}

        {data.map((items) => {
          return (
            <Accordion key={items.title} expanded={true}>
              <AccordionSummary
                aria-controls="panel1d-content"
                id="panel1d-header"
                sx={{
                  cursor: 'default !important'
                }}
              >
                <Typography
                  sx={{
                    '::before': {
                      content: '""',
                      display: 'inline-block',
                      width: 4,
                      height: '1.25rem',
                      bgcolor: 'primary.main',
                      position: 'absolute',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      left: '-10px'
                    },
                    lineHeight: '1.25em',
                    position: 'relative',
                    ml: '10px'
                  }}
                >
                  {t('Publication')}
                </Typography>
              </AccordionSummary>

              <AccordionDetails>
                <Box>
                  {/* <Typography>
                    Mastermind:
                    <Link
                      onClick={() => {
                        window.open(
                          `${ExternalLinks.mastermind}?disease=all%20diseases&gene=${props.props.row.gene}&mutation=${props.props.row.mastermind_MMID3}`
                        )
                      }}
                      sx={{
                        cursor: 'pointer'
                      }}
                    >
                      {props.value.reduce(
                        (sum, e) => sum + Number(e.num_versions || 0),
                        0
                      )}{' '}
                      articles
                      <OpenInNew sx={{ fontSize: '1.125rem' }} />
                    </Link>
                  </Typography> */}

                  <Box sx={{ width: '100%' }}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                      <Tabs
                        value={value}
                        onChange={handleChange}
                        aria-label="basic tabs example"
                        sx={{
                          position: 'relative'
                        }}
                        variant="scrollable"
                        scrollButtons
                        allowScrollButtonsMobile
                      >
                        <Tab
                          sx={{
                            textTransform: 'capitalize'
                          }}
                          label={`${t(
                            'Site annotation associated literature'
                          )} (${
                            props.value.variantPubmedArticles
                              ? props.value.variantPubmedArticles.length
                              : 0
                          })`}
                          {...a11yProps(0)}
                        />

                        <Tab
                          sx={{
                            textTransform: 'capitalize'
                          }}
                          label={`${t('Real-time search')}(${
                            (props.litVarArticles?.count ?? 0) +
                            (props.value.scholarArticles
                              ? props.value.scholarArticles.length
                              : 0)
                          })`}
                          {...a11yProps(1)}
                        />

                        {/* <Tab
                          sx={{
                            textTransform: 'capitalize'
                          }}
                          label={`LitVar (${props.litVarArticles?.count ?? 0})`}
                          {...a11yProps(2)}
                        /> */}

                        <Tab
                          sx={{
                            textTransform: 'capitalize'
                          }}
                          label={`${t(
                            'GLS AI literature database interpretation'
                          )}(${
                            variantsArticles && variantsArticles.details
                              ? variantsArticles.details[0]?.pubmed_articles
                                  ?.literatures.length
                              : 0
                          })`}
                          {...a11yProps(2)}
                        />

                        <Tab
                          sx={{
                            textTransform: 'capitalize'
                          }}
                          label={`${t('HGMD免费版')}`}
                          {...a11yProps(3)}
                        />

                        {/* <Tab
                          sx={{
                            textTransform: 'capitalize'
                          }}
                          label={`GLS AI (${
                            variantsArticles && variantsArticles.details
                              ? variantsArticles.details[0]?.pubmed_articles
                                  ?.literatures.length
                              : 0
                          })`}
                          {...a11yProps(4)}
                        /> */}

                        <Stack
                          position={'absolute'}
                          sx={{
                            right: 0,
                            top: 0,
                            bottom: 0,
                            margin: 'auto 0'
                          }}
                          justifyContent={'center'}
                          alignItems={'center'}
                        >
                          {isWindow() ? (
                            <LoadingButton
                              variant="contained"
                              onClick={(e) => {
                                e.stopPropagation()

                                inputRef.current?.click()
                              }}
                              loading={loading}
                            >
                              {t('Upload PDF interpretation')}
                            </LoadingButton>
                          ) : null}

                          <input
                            style={{
                              display: 'none'
                            }}
                            onChange={async (e) => {
                              e.stopPropagation()

                              //

                              if (e.target.files) {
                                const file = e.target.files[0]

                                setFile(file)

                                // 创建一个FileReader实例

                                const reader = new FileReader()

                                // 读取文件内容作为ArrayBuffer

                                reader.readAsArrayBuffer(file)

                                reader.onload = async function () {
                                  // 当读取完成，result属性将包含一个ArrayBuffer
                                  setLoading(true)
                                  const arrayBuffer =
                                    reader.result as ArrayBuffer

                                  // 将ArrayBuffer转换为Uint8Array

                                  const uint8Array = new Uint8Array(arrayBuffer)

                                  // 现在你可以使用uint8Array了，比如将其发送到服务器

                                  const pdfDocument =
                                    await pdfjsLib.getDocument(uint8Array)
                                      .promise

                                  // 获取PDF文档的总页数
                                  const numPages = pdfDocument.numPages

                                  const pdfAllcontent = [] // 读取每一页的内容

                                  for (let i = 1; i <= numPages; i++) {
                                    const page = await pdfDocument.getPage(i)
                                    const content = await page.getTextContent()
                                    const text = content.items
                                      .map((item: any) => item.str)
                                      .join('')

                                    pdfAllcontent.push(`Page ${i}: ${text}`)
                                  }

                                  //
                                  const pdfStr = `请用中文解读一下文献：${pdfAllcontent.join(
                                    '\n'
                                  )}`
                                  const newChat = [
                                    // ...historyMsg,
                                    {
                                      message: pdfStr,
                                      sentTime: formatDate(new Date()) ?? '',
                                      sender: 'user',
                                      direction: MessageDirection.OUT,
                                      position: 'last'
                                    }
                                  ]

                                  setHistoryMsg(newChat)

                                  const param = {
                                    messages: {
                                      messages: newChat
                                        .filter((item) => item.sender !== 'sys')
                                        .map((item) => {
                                          return {
                                            role: item.sender,
                                            content: `${item.message}`
                                          }
                                        })
                                    },
                                    his: newChat
                                  }

                                  await getChatClaudes(param)

                                  setLoading(false)

                                  return pdfAllcontent
                                }

                                // 监听FileReader的error事件（可选）

                                reader.onerror = function () {
                                  setLoading(false)

                                  console.error('文件读取失败', reader.error)
                                }
                              }
                            }}
                            type="file"
                            ref={inputRef}
                          />
                        </Stack>
                      </Tabs>
                    </Box>

                    {/* <CustomTabPanel value={value} index={1}>
                      {props.value.genePubmedArticles
                        ? props.value.genePubmedArticles.map((items) => {
                            return (
                              <Article
                                value={items}
                                type="gene"
                                row={props.row}
                                handleOpen={props.handleOpen}
                              />
                            )
                          })
                        : ''}
                    </CustomTabPanel> */}

                    <CustomTabPanel value={value} index={0}>
                      {/* {Article(
                        props.value.variantPubmedArticles ?? [],
                        'variant',
                        props.row
                      )} */}
                      {props.value.variantPubmedArticles
                        ? props.value.variantPubmedArticles.map((items) => {
                            return (
                              <Article
                                value={items}
                                type="variant"
                                row={props.row}
                                handleOpen={props.handleOpen}
                              />
                            )
                          })
                        : ''}
                    </CustomTabPanel>

                    <CustomTabPanel value={value} index={3}>
                      <Box flex={5} sx={{ padding: '10px 5px' }}>
                        {props.hgmdValue.length ? (
                          <TableContainer
                            sx={{
                              minWidth: '100%',
                              width: 'max-content'
                            }}
                          >
                            <Table>
                              <TableBody>
                                {props.hgmdValue.map((item) => {
                                  return (
                                    <TableRow key={item?.name}>
                                      <TableCell
                                        sx={{
                                          paddingBottom: '8px !important',
                                          paddingTop: '8px !important',
                                          paddingRight: 0
                                        }}
                                      >
                                        {item?.name}
                                      </TableCell>

                                      <TableCell
                                        sx={{
                                          textAlign: 'right',
                                          paddingBottom: '8px !important',
                                          paddingTop: '8px !important',
                                          paddingRight: 0
                                        }}
                                      >
                                        {item?.value}
                                      </TableCell>
                                    </TableRow>
                                  )
                                })}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        ) : (
                          <Typography textAlign={'center'}>
                            {t('No Results')}
                          </Typography>
                        )}
                      </Box>
                    </CustomTabPanel>

                    <CustomTabPanel value={value} index={2}>
                      {/* {Article(
                        props.value.variantPubmedArticles ?? [],
                        'variant',
                        props.row
                      )} */}
                      {variantsArticles &&
                      variantsArticles.details &&
                      variantsArticles.details[0]?.pubmed_articles
                        ?.summarization ? (
                        <React.Fragment>
                          <Typography
                            color="#237aaa"
                            py={4}
                            sx={{
                              overflow: 'hidden',
                              wordBreak: 'break-word',
                              whiteSpace: 'pre-wrap',
                              fontSize: '1rem'
                            }}
                          >
                            {translates
                              ? translates
                              : variantsArticles.details[0]?.pubmed_articles
                                  ?.summarization}
                          </Typography>
                        </React.Fragment>
                      ) : (
                        ''
                      )}

                      {variantsArticles && variantsArticles.details ? (
                        <React.Fragment>
                          <Stack direction={'row'} spacing={2}>
                            <Typography fontSize={18} color="#237aaa" py={1}>
                              {'ACMG Classification:'}
                            </Typography>

                            <Box
                              sx={{
                                p: 2,
                                color: 'white',
                                backgroundColor:
                                  ACMGClassification.find(
                                    (item) =>
                                      item.key ===
                                        variantsArticles.details[0]
                                          ?.acmg_classification ||
                                      item.title ===
                                        variantsArticles.details[0]
                                          ?.acmg_classification
                                  )?.color ?? 'rgba(229,38,35,0.8)',
                                borderRadius: '5px'
                              }}
                            >
                              {variantsArticles.details[0]?.acmg_classification}
                            </Box>
                          </Stack>

                          <Typography fontSize={18} color="#237aaa" py={1}>
                            {'ACMG Evidence:'}
                          </Typography>

                          {acmg && acmg.length
                            ? acmg.map((item: string) => {
                                return (
                                  <Typography fontSize={16} pt={2}>
                                    <Typography
                                      sx={{
                                        overflow: 'hidden',
                                        wordBreak: 'break-word',
                                        whiteSpace: 'pre-wrap',
                                        fontSize: '1rem'
                                      }}
                                      color="#237aaa"
                                    >
                                      {item}
                                    </Typography>
                                  </Typography>
                                )
                              })
                            : ''}

                          <Stack
                            direction={'row'}
                            justifyContent="space-between"
                            py={2}
                          >
                            <Paper
                              component="form"
                              sx={{
                                p: '2px 4px',
                                display: 'flex',
                                alignItems: 'center',
                                width: 400,
                                height: '3rem'
                              }}
                            >
                              <InputBase
                                sx={{ ml: 1, flex: 1 }}
                                placeholder={`${t(
                                  'Please enter PMID and press Enter'
                                )}`}
                                inputProps={{ 'aria-label': 'search' }}
                                value={search}
                                onChange={(e) => {
                                  setSearch(e.target.value)
                                }}
                                onKeyDown={(e) => {
                                  if (e.key === 'Enter') {
                                    e.preventDefault()

                                    setSearchValue(search)
                                  }
                                }}
                              />

                              <IconButton
                                type="button"
                                sx={{ p: '10px' }}
                                aria-label="search"
                                onClick={() => {
                                  setSearchValue(search)
                                }}
                              >
                                <SearchIcon />
                              </IconButton>
                            </Paper>

                            <Box display={'flex'} alignItems="center">
                              <Button
                                variant="contained"
                                size="small"
                                onClick={async () => {
                                  if (translates) {
                                    setAcmg(
                                      variantsArticles.details[0]?.acmg
                                        ?.filter(
                                          (item: any) => item.code_status
                                        )
                                        .map(
                                          (item: any) =>
                                            `${item.code_name}:${item.evidence}`
                                        )
                                    )

                                    return setTranslates('')
                                  }
                                  const sourceLanguage = 'en',
                                    targetLanguage = 'zh'

                                  const params: TranslateDto = {
                                    sourceText:
                                      variantsArticles.details[0]
                                        ?.pubmed_articles?.summarization,
                                    sourceLanguage,
                                    targetLanguage
                                  }

                                  if (params.sourceText) {
                                    const data = await Translate.mutateAsync(
                                      params
                                    )

                                    setTranslates(data)
                                  }

                                  const datas = await Promise.all(
                                    acmg.map(async (item) => {
                                      const params: TranslateDto = {
                                        sourceText: item,
                                        sourceLanguage,
                                        targetLanguage
                                      }

                                      return await Translate.mutateAsync(params)
                                    })
                                  )

                                  setAcmg(datas)
                                }}
                              >
                                {t('translate')}
                              </Button>
                            </Box>
                          </Stack>
                        </React.Fragment>
                      ) : (
                        ''
                      )}

                      {variantsArticles && variantsArticles.details
                        ? variantsArticles.details[0]?.pubmed_articles?.literatures
                            ?.filter(
                              (item: any) =>
                                item.pmid &&
                                `${item.pmid}`.includes(searchValue)
                            )
                            .map((items: any) => {
                              return (
                                <Article
                                  acmg={variantsArticles.details[0]?.acmg
                                    ?.filter((item: any) => item.code_status)
                                    .map(
                                      (item: any) =>
                                        `${item.code_name}:${item.evidence}`
                                    )}
                                  acmg_classification={
                                    variantsArticles.details[0]
                                      ?.acmg_classification
                                  }
                                  acmg_summary={
                                    variantsArticles.details[0]?.acmg_summary
                                  }
                                  value={items}
                                  type="variants"
                                  row={props.row}
                                  handleOpen={props.handleOpen}
                                  summarization={''}
                                />
                              )
                            })
                        : ''}
                    </CustomTabPanel>

                    <CustomTabPanel value={value} index={1}>
                      <Tabs
                        value={value2}
                        onChange={(e, value) => setValue2(value)}
                        aria-label="basic tabs example"
                        sx={{
                          position: 'relative'
                        }}
                      >
                        <Tab
                          sx={{
                            textTransform: 'capitalize'
                          }}
                          label={`LitVar (${props.litVarArticles?.count ?? 0})`}
                          {...a11yProps(0)}
                        />

                        <Tab
                          sx={{
                            textTransform: 'capitalize'
                          }}
                          label={`Google Scholar(${
                            props.value.scholarArticles
                              ? props.value.scholarArticles.length
                              : 0
                          })`}
                          {...a11yProps(1)}
                        />
                      </Tabs>

                      <CustomTabPanel value={value2} index={0}>
                        {props.litVarArticles &&
                        props.litVarArticles.count &&
                        props.litVarArticles.page_size ? (
                          <Stack
                            spacing={2}
                            alignItems="center"
                            justifyContent={'center'}
                            py={2}
                          >
                            <Typography>
                              {`Showing 1 to ${props.litVarArticles.page_size} of ${props.litVarArticles.count} publications.`}
                            </Typography>

                            <Pagination
                              count={Math.ceil(
                                props.litVarArticles.count /
                                  props.litVarArticles.page_size
                              )}
                              renderItem={(item) => (
                                <PaginationItem
                                  slots={{
                                    previous: ArrowBackIcon,
                                    next: ArrowForwardIcon
                                  }}
                                  {...item}
                                />
                              )}
                              page={props.page}
                              onChange={(e, value) => {
                                props.setLitPage(value)

                                props.getLitVarArticle.mutateAsync({
                                  rsId: props.row.rs_id,
                                  litPage: value
                                })
                              }}
                            />
                          </Stack>
                        ) : (
                          ''
                        )}

                        {props.litVarArticles &&
                        props.litVarArticles.results &&
                        Array.isArray(props.litVarArticles.results)
                          ? props.litVarArticles.results.map((items: any) => {
                              return (
                                <Article
                                  value={items}
                                  type="LitVar"
                                  row={props.row}
                                  handleOpen={props.handleOpen}
                                />
                              )
                            })
                          : ''}
                      </CustomTabPanel>

                      <CustomTabPanel value={value2} index={1}>
                        {props.value.scholarArticles
                          ? props.value.scholarArticles.map((items) => {
                              return (
                                <Article
                                  value={items}
                                  type="scholar"
                                  row={props.row}
                                  handleOpen={props.handleOpen}
                                />
                              )
                            })
                          : ''}
                      </CustomTabPanel>
                    </CustomTabPanel>
                  </Box>
                </Box>
              </AccordionDetails>
            </Accordion>
          )
        })}
      </Box>
    )
  }
)

export default RelatedLiterature
